import { Translation } from '../models';

export function filterTranslationByLanguage(language: string, translations: Translation[]): any {
    if (!!language) {
        let filteredTranslation = {};

        translations.forEach((translationLanguage) => {
            if (!!translationLanguage.id && translationLanguage.id === language) {
                filteredTranslation = { ...JSON.parse(JSON.stringify(translationLanguage.content)), ...filteredTranslation };
            }
        });

        return filteredTranslation;
    }
}